import { createSlice } from '@reduxjs/toolkit';

export const filterSlice = createSlice({
    name: 'filters',
    initialState: {
        Compostions: [],
        locationBoxOrPincode: {
            locationBox: '0'
        },
        productTitleOrKeywords: {
            ProductName: '0'
        },
        locations: [],
        productLanguage: [],
        hoursPerWeek: [],
        sortDirection: 'desc'
    },
    reducers: {
        pushFilterLocation: (state, action) => {
            state.locations = action.payload;
        },
        popFilterLocation: (state) => {
            state.locations = [];
        },
        pushFilterEmployment: (state, action) => {
            state.Compostions = action.payload;
        },
        popFilterEmployment: (state) => {
            state.Compostions = [];
        },
        pushFilterProductTitleOrKeywords: (state, action) => {
            state.productTitleOrKeywords = action.payload;
        },
        popFilterProductTitleOrKeywords: (state) => {
            state.productTitleOrKeywords = {
                ProductName: '0'
            };
        },
        pushFilterLocationBoxOrPincode: (state, action) => {
            state.locationBoxOrPincode = action.payload;
        },
        popFilterLocationBoxOrPincode: (state) => {
            state.locationBoxOrPincode = {
                locationBox: '0'
            };
        },
        pushFilterProductLanguage: (state, action) => {
            state.productLanguage = action.payload;
        },
        popFilterProductLanguage: (state) => {
            state.productLanguage = [];
        },
        pushFilterHoursPerWeek: (state, action) => {
            state.hoursPerWeek = action.payload;
        },
        popFilterHoursPerWeek: (state) => {
            state.hoursPerWeek = [];
        },
        pushFilterSortDirection: (state, action) => {
            state.sortDirection = action.payload;
        },
        popFilterSortDirection: (state) => {
            state.sortDirection = 'desc';
        },
        popClearAllFilters: (state) => {
            state.hoursPerWeek = [];
            state.productLanguage = [];
            state.locationBoxOrPincode = {
                locationBox: '0'
            };
            state.productTitleOrKeywords = {
                ProductName: '0'
            };
            state.Compostions = [];
            state.locations = [];
            state.sortDirection = 'desc';
        }
    },
});

export const { pushFilterEmployment, pushFilterHoursPerWeek, pushFilterProductLanguage, pushFilterProductTitleOrKeywords, 
    pushFilterLocation, pushFilterLocationBoxOrPincode, popFilterEmployment, popFilterHoursPerWeek, popFilterProductLanguage, 
    popFilterProductTitleOrKeywords, popFilterLocation, popFilterLocationBoxOrPincode, popClearAllFilters, 
    pushFilterSortDirection, popFilterSortDirection } = filterSlice.actions;

export const selectEmploymentType = (state) => state.filters.Compostions;
export const selectProductTitleOrKeywords = (state) => state.filters.productTitleOrKeywords;
export const selectLocationBoxOrPincode = (state) => state.filters.locationBoxOrPincode;
export const selectLocations = (state) => state.filters.locations;
export const selectProductLanguage = (state) => state.filters.productLanguage;
export const selectHoursPerWeek = (state) => state.filters.hoursPerWeek;
export const selectSortDirection = (state) => state.filters.sortDirection;

export default filterSlice.reducer;